import type {ComponentProps} from 'react';

import {Tag} from '@/modules/commerce/tag';
import {cn} from '@/modules/foundation/shared/tailwind';
import type {CommerceBrand} from '@/sanity/schemas/types';

type Props = ComponentProps<'div'> & {
	brands: CommerceBrand[];
};

export default function ProductBrandTags({brands, className, children, ...rest}: Props) {
	return (
		<div className={cn('flex flex-wrap gap-2', className)} {...rest}>
			{children}
			{brands.map((brand) => (
				<Tag key={brand._id}>{brand.name}</Tag>
			))}
		</div>
	);
}
